import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/NewspaperArticleList.vue"),
    meta: {
      title: "Newspaper Articles",
    },
    name: "newspaper-article-list",
    path: "/newspaper_articles",
  },
  {
    component: () => import("pages/NewspaperArticleEdit.vue"),
    meta: {
      title: "New Newspaper Article",
    },
    name: "paper-articles-new",
    path: "/newspaper_articles/new",
    props: true,
  },
  {
    component: () => import("pages/NewspaperArticleEdit.vue"),
    meta: {
      title: "Edit Newspaper Article",
    },
    name: "newspaper-article-edit",
    path: "/newspaper_articles/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/NewspaperList.vue"),
    meta: {
      title: "Newspapers",
    },
    name: "newspapers-list",
    path: "/newspapers",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/ViewerPage.vue"),
    name: "newspaper-viewer",
    path: "/newspaper-viewer",
    props: { sourceType: "newspaper", title: "Newspaper Viewer" },
  },
  {
    component: () => import("pages/NewspaperEdit.vue"),
    meta: {
      title: "New Newspaper",
    },
    name: "newspapers-new",
    path: "/newspapers/new",
    props: true,
  },
  {
    component: () => import("pages/NewspaperEdit.vue"),
    meta: {
      title: "Edit Newspaper",
    },
    name: "newspapers-edit",
    path: "/newspapers/:id/edit",
    props: true,
  },
  {
    component: () => import("pages/PrintPageList.vue"),
    meta: {
      title: "Newspaper Pages",
    },
    name: "newspaper-pages-index",
    path: "/newspaper-pages",
    props: { type: "newspaper_page" },
  },
];
